import { useEffect, useState } from "react"
import styles from "./Header.module.scss"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { FormControl, Dropdown, Navbar, InputGroup } from "react-bootstrap"
import Avatar from "react-avatar"
import { useDispatch, useSelector } from "react-redux"
import { logoutUser } from "../../redux/actions"
import { selectWebsiteData } from "../../redux/general/selectors"
import { selectAuthUser } from "../../redux/auth/selectors"
import { handleLogoutUser } from "../../screens/Logout"
import { useLocalization } from "../../providers/LocalizationProvider"
import { replacePlaceholder, updateLanguage } from "../../utils"
import { showWarning } from "../../utils/snackbar"
import { LANGUAGE_OPTIONS } from "../../Data/constant"

const Header = ({ fullView }) => {
    const userData = useSelector(selectAuthUser)
    const websiteData = useSelector(selectWebsiteData)
    const dispatch = useDispatch()
    const location = useLocation()
    const [userDetail, setUserDetail] = useState()
    const navigate = useNavigate()
    const { setLanguage, voiceiiTags, setVoiceiiObjectData, language } = useLocalization()

    let BASE_URL = process.env.REACT_APP_API_URL
    const routeChange = async () => {
        const lang = localStorage.getItem("language")
        const tag = localStorage.getItem("voiceiiObjectData")
        await handleLogoutUser()
        dispatch(logoutUser())
        if (lang) {
            localStorage.setItem("language", lang)
        }
        if (tag) {
            localStorage.setItem("voiceiiObjectData", tag)
        }
    }

    useEffect(() => {
        sessionStorage.setItem("isLoggedIn", true)
    }, [])

    useEffect(() => {
        const snackbarDisplayed = localStorage.getItem("snackbarDisplayed")
        const storedUserDetail = localStorage.getItem("user")
        const parsedUserDetail = JSON.parse(storedUserDetail)
        setUserDetail(parsedUserDetail)
        if (storedUserDetail && !snackbarDisplayed) {
            if (
                parsedUserDetail.password_expires_in_days <= 7 &&
                parsedUserDetail.is_password_complexity_valid === true
            ) {
                showWarning(
                    `${voiceiiTags("Your password expires in")}${parsedUserDetail.password_expires_in_days} ${voiceiiTags("days, kindly update it now")}`,
                    {
                        anchorOrigin: {
                            horizontal: "right",
                            vertical: "top",
                        },
                        style: { marginTop: "55px" },
                    },
                )
            }
            localStorage.setItem("snackbarDisplayed", true)
        }
    }, [])

    //leftsidemenu
    const SideMenuIcon = () => {
        document.querySelector(".app").classList.toggle("sidenav-toggled")
    }

    useEffect(() => {
        document.getElementById("header").style.paddingInlineStart = "10px"
    }, [fullView])

    const isWavsmart = BASE_URL === "https://wavsmart.efleety.com/"

    const defaultPrimary = isWavsmart ? "#00bc7f" : "#000000"

    const tertiaryColor = websiteData.tertiary || "#ffffff"
    const primaryColor = websiteData.primary_colour || defaultPrimary

    return (
        <>
            {/* Header drawer */}
            <div
                className={styles.Header}
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    zIndex: 1000,
                    display: location.pathname !== "/" ? "none" : "block",
                    transition: "all 0.3s",
                }}
            >
                <style>
                    {` 
           .btn-secondary {
           background-color: ${primaryColor} !important;
           color: ${tertiaryColor} !important;
           
           }

           .app-header {
            background-color: ${tertiaryColor};
           }
          `}
                </style>

                <div
                    id="header"
                    className="header sticky app-header header1 custom-header ps-0 p-1"
                >
                    <div className="container-fluid main-container ps-0">
                        <div style={{ height: "40px", marginLeft: "-16.5px" }} className="d-flex">
                            <Link
                                aria-label="Hide Sidebar"
                                className="app-sidebar__toggle"
                                data-bs-toggle="sidebar"
                                to="#"
                                onClick={() => SideMenuIcon()}
                            />

                            <div className="main-header-center ms-3 d-none d-lg-block"></div>
                            <Navbar
                                className="d-flex order-lg-2 ms-auto header-right-icons"
                                style={{ gap: "4px" }}
                            >
                                <Dropdown className="dropdown d-none">
                                    <Link to="#" className="nav-link icon ">
                                        <i className="fe fe-search"></i>
                                    </Link>
                                    <Dropdown.Menu className="header-search dropdown-menu-start ">
                                        <InputGroup className="input-group w-100 p-2">
                                            <FormControl type="text" placeholder="Search...." />
                                            <InputGroup.Text className="btn btn-primary">
                                                <i className="fe fe-search" aria-hidden="true"></i>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Dropdown.Menu>
                                </Dropdown>
                                {/* //TODO : Take this section to sidebar as well  */}
                                {location.pathname === "/" && (
                                    <>
                                        {" "}
                                        <Navbar.Toggle
                                            className="d-lg-none ms-auto header2 navbar-toggler navresponsive-toggler"
                                            style={{ marg: "40px" }}
                                        >
                                            <span className="navbar-toggler-icon fe fe-more-vertical"></span>
                                        </Navbar.Toggle>
                                        <div className="responsive-navbar navbar p-0">
                                            <Navbar.Collapse
                                                className=""
                                                id="navbarSupportedContent-4"
                                            >
                                                <div className="d-flex order-lg-2">
                                                    <Dropdown className="d-flex profile-1">
                                                        <Dropdown.Toggle
                                                            variant=""
                                                            className="nav-link leading-none d-flex no-caret"
                                                        >
                                                            <Avatar
                                                                fgColor={
                                                                    location.pathname == "/"
                                                                        ? "black"
                                                                        : websiteData.primary
                                                                }
                                                                color={
                                                                    location.pathname == "/"
                                                                        ? "red"
                                                                        : websiteData.secondary
                                                                }
                                                                round
                                                                size="35"
                                                                name={`${userData.first_name} ${userData.last_name}`}
                                                            />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu className="dropdown-menu-end dropdown-menu-arrow">
                                                            <div className="drop-heading">
                                                                <div className="text-center">
                                                                    <h5 className="text-dark mb-0 fs-14 fw-semibold">
                                                                        {userData.first_name}
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                            {userDetail && (
                                                                <div
                                                                    className="text-danger"
                                                                    style={{
                                                                        marginBottom: "10px",
                                                                        marginTop: "-5px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {replacePlaceholder(
                                                                        voiceiiTags("expire_text"),
                                                                        userDetail.password_expires_in_days,
                                                                    )}
                                                                </div>
                                                            )}

                                                            <div className="dropdown-divider m-0"></div>
                                                            <Dropdown.Item
                                                                className="dropdown-item"
                                                                onClick={() => {
                                                                    let path = `${process.env.PUBLIC_URL}/change-password`
                                                                    // window.location.href = path
                                                                    navigate(path)
                                                                }}
                                                            >
                                                                <i className="dropdown-icon fe fe-lock"></i>{" "}
                                                                {voiceiiTags("Change Password")}
                                                            </Dropdown.Item>
                                                            <Dropdown
                                                                drop="start"
                                                                className="dropdown-item"
                                                            >
                                                                <Dropdown.Toggle
                                                                    as="div"
                                                                    className="lng-item p-0"
                                                                    style={{ marginLeft: "-7px" }}
                                                                >
                                                                    <i className="dropdown-icon fe fe-globe"></i>
                                                                    <span className="ms-1">
                                                                        {
                                                                            LANGUAGE_OPTIONS[
                                                                                language
                                                                            ]?.flag
                                                                        }{" "}
                                                                        {LANGUAGE_OPTIONS[language]
                                                                            ?.label ||
                                                                            voiceiiTags("Language")}
                                                                    </span>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu className="pt-2 pb-2">
                                                                    {Object.entries(
                                                                        LANGUAGE_OPTIONS,
                                                                    ).map(([langCode, lang]) => (
                                                                        <Dropdown.Item
                                                                            key={langCode}
                                                                            disabled={
                                                                                language ===
                                                                                langCode
                                                                            }
                                                                            className={`e-lang-item ${language === langCode ? "lang-active" : ""}`}
                                                                            onClick={() => {
                                                                                updateLanguage(
                                                                                    langCode,
                                                                                    setLanguage,
                                                                                    setVoiceiiObjectData,
                                                                                    voiceiiTags,
                                                                                )
                                                                            }}
                                                                        >
                                                                            <span className="me-2">
                                                                                {lang.flag}
                                                                            </span>
                                                                            {lang.label}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                            <Dropdown.Item
                                                                className="dropdown-item"
                                                                onClick={() => {
                                                                    routeChange()
                                                                    localStorage.removeItem(
                                                                        "menuitems",
                                                                    ) // The menuitems are removed from localstorage when a user logs-out of a certain tile.
                                                                    localStorage.removeItem(
                                                                        "isNodeView",
                                                                    )
                                                                    localStorage.removeItem(
                                                                        "zoneId",
                                                                    )
                                                                }}
                                                            >
                                                                <i className="dropdown-icon fe fe-alert-circle"></i>{" "}
                                                                {voiceiiTags("Sign out")}
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </Navbar.Collapse>
                                        </div>
                                    </>
                                )}
                            </Navbar>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Header
